import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import ViewModuleIcon from "@mui/icons-material/ViewModule";
import HomeIcon from "@mui/icons-material/Home";
import EditNoteIcon from "@mui/icons-material/EditNote";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupIcon from "@mui/icons-material/Group";
import Logo from "../shared/logo";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/store";
import { logout } from "@/store/slices/auth/slice";
import { FileSliders, Shield, Percent, ImageIcon } from "lucide-react";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <nav aria-label='dashboard-sidebar' className='w-[340px] sticky top-0'>
      <div className='p-4 flex flex-col gap-y-4'>
        <Logo />
        <span className='text-xs text-black/60'>CMS Panel</span>
      </div>
      <List className='w-full'>
        {[
          { icon: <HomeIcon />, title: "Home", href: "/dashboard" },
          { icon: <ViewModuleIcon />, title: "Modules", href: "/modules" },
          { icon: <EditNoteIcon />, title: "Statics", href: "/statics" },
          { icon: <Percent />, title: "Discounts", href: "/discounts" },
          { icon: <GroupIcon />, title: "Users", href: "/users" },
          { icon: <Shield />, title: "Roles", href: "/roles" },
          {
            icon: <FileSliders />,
            title: "Primary Fields",
            href: "/primary-fields",
          },
          { icon: <ImageIcon />, title: "Media", href: "/media" },
        ].map((item) => (
          <ListItem disablePadding>
            <ListItemButton
              selected={location?.pathname === item.href}
              onClick={() => navigate(item.href)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItemButton>
        </ListItem>
      </List>
    </nav>
  );
}
